import { NumberStepInput, Typography } from '@coolblue-development/freddy';
import changeQuantityTrigger from '@coolblue-development/ga4-events/triggers/QuantitySelector/changeQuantityTrigger';
import showTrigger from '@coolblue-development/ga4-events/triggers/QuantitySelector/showTrigger';
import { TrackImmediate, useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';
import { useState } from 'react';

type QuantityStepperProps = {
  productType: string;
  updateProductQuantity: (value: number) => void;
  productId: number;
};

const QuantityStepper = ({
  productType,
  productId,
  updateProductQuantity
}: QuantityStepperProps) => {
  const numberStepInputTranslations = useFreddyTranslations('numberStepInput');
  const { t } = useTranslation('webshop.business.quantityStepper');
  const { trackEvent } = useAnalytics();

  const [selectedQuantity, setSelectedQuantity] = useState(1);

  const handleQuantityChange = (value: number) => {
    const prevQty = selectedQuantity;
    const isAmountIncreasing = value > prevQty;

    setSelectedQuantity(value);
    updateProductQuantity(value);

    trackEvent(
      changeQuantityTrigger({
        sub_feature: 'order_block',
        item_id: productId,
        type: isAmountIncreasing ? 'add' : 'remove',
        quantity: value
      })
    );
  };

  return (
    <div>
      <TrackImmediate trigger={showTrigger()} />

      <Typography variant='h5' component='p' mb={200}>
        {productType ? t('productType', { productType: productType.toLowerCase() }) : t('default')}
      </Typography>
      <NumberStepInput
        name='quantity'
        size='small'
        min={1}
        defaultValue={1}
        onChange={handleQuantityChange}
        translations={numberStepInputTranslations}
      />
    </div>
  );
};

export default QuantityStepper;
